import { AxiosResponse } from 'axios';

import { $api } from '@shared/api';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const getEnablePoll = (): Promise<AxiosResponse<IDataResponse<{ need: boolean }>>> => {
    // @ts-ignore
    const getEnablePollUrl = routable.getRoute('getEnablePoll');

    return $api.get(getEnablePollUrl);
};
